/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { ComercialformItems } from '../../data/contact';
import { comercialFormDataType, comercialSchema } from '../../data/validations/contactSchemas';
import { useForms } from '../../hooks/useForms';
import Button from '../Button/Button';
import InputForm from '../InputForm/InputForm';
import styles from './ComercialForms.module.scss';

export default function ComercialForms() {
    const { formData, handleFormChange, validFields, handleEmitForm } = useForms(comercialSchema, {
        name: '',
        last_name: '',
        email: '',
        phone: '',
        company_name: '',
        department: '',
        subject: '',
        message: '',
        cnpj: '',
    });

    return (
        <div className={styles.form}>
            {ComercialformItems.map((item) => (
                <InputForm
                    key={item.inputName}
                    label={item.label}
                    inputName={item.inputName}
                    typeInput={item.typeInput}
                    isTextArea={item.isTextArea}
                    onChangeInput={handleFormChange}
                    value={formData[item.inputName as keyof comercialFormDataType]}
                    isValidField={validFields[item.inputName as keyof comercialFormDataType]}
                    pattern={item.pattern}
                    placeholder={item.placeholder}
                />
            ))}
            <Button
                text="enviar formulário"
                onClickButton={() => void handleEmitForm('api/comercial')}
            />
        </div>
    );
}
